import { TTranslation } from '../../models/translation/translation';
import { useApiClient } from '../apiClients';
import { ENDPOINTS_TRANSLATIONS } from './endpoints';

export const useTranslateApi = () => {
  const apiClient = useApiClient();

  const getTranslations = () =>
    apiClient.get<TTranslation[]>(ENDPOINTS_TRANSLATIONS.GET_ALL);

  const saveTranslations = (items: TTranslation[]) =>
    apiClient.post<TTranslation[]>(ENDPOINTS_TRANSLATIONS.SAVE, items);

  return {
    getTranslations,
    saveTranslations,
  };
};
